
import { defineComponent } from 'vue'
import { getAbbreviationFromUser } from '../utils'
import { createNamespacedHelpers } from 'vuex-composition-helpers'

const { useGetters: useUserGetters, useActions: useUserActions } = createNamespacedHelpers('user')

export default defineComponent({
  setup() {
    const { logout } = useUserActions(['logout'])
    const { user } = useUserGetters(['user'])
    const clientUrl = process.env.VUE_APP_CLIENT_URI || 'http://localhost:4200'
    const helpCenterUrl = 'https://intercom.help/backbone-help-center/en'

    async function processLogout() {
      await logout()
      window.location.href = `${clientUrl}`
    }

    async function navigateToHelpCenter() {
      window.open(helpCenterUrl)
    }

    return {
      user,
      clientUrl,
      helpCenterUrl,
      processLogout,
      navigateToHelpCenter,
      getAbbreviationFromUser
    }
  }
})
